module.exports = __webpack_public_path__ + "img/foto_blur_tuin.a6c0b1c7.jpg";